import { SegmentedControl, SegmentedControlItem } from '@astryxdesign/core/SegmentedControl';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import type { PublicTenant } from '@/features/tenant/schemas';

export function VehicleClassPicker({ tenant, value, onChange, label = 'Класс автомобиля' }: { tenant: PublicTenant; value: string | null; onChange: (id: string) => void; label?: string }) {
  const selected = tenant.vehicle_classes.find((c) => c.id === value);
  return (
    <VStack gap={1.5}>
      <SegmentedControl label={label} value={value ?? ''} onChange={onChange} layout="fill">
        {tenant.vehicle_classes.map((c) => (
          <SegmentedControlItem key={c.id} value={c.id} label={c.name} />
        ))}
      </SegmentedControl>
      <Text size="sm" color="secondary" aria-live="polite">
        {selected ? (selected.description ?? selected.name) : 'Выберите класс автомобиля — от него зависит цена'}
      </Text>
    </VStack>
  );
}
